import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import usePermissions from '../hooks/usePermissions';

/**
 * Route guard: renders children only if the user may open this page in the selected organization.
 * Otherwise sends them to the first page they can see. Re-checks when the org pulldown changes,
 * so switching to an org with a smaller role moves the user off a page they can no longer use.
 */
function RequirePermission({ children }) {
  const location = useLocation();
  const { canOpen, fallbackPath } = usePermissions();

  if (!canOpen(location.pathname)) {
    const target = fallbackPath === location.pathname ? '/profile' : fallbackPath;
    return <Navigate to={target} replace />;
  }
  return children;
}

export default RequirePermission;
